// src/pages/UserGuide.js
import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';

const UserGuide = () => {
  const { language } = useLanguage();
  const isArabic = language === 'ar';

  const containerStyle = {
    maxWidth: '800px',
    margin: '0 auto',
    padding: '20px',
    direction: isArabic ? 'rtl' : 'ltr',
    textAlign: isArabic ? 'right' : 'left',
    fontFamily: isArabic ? 'Cairo, sans-serif' : 'Segoe UI'
  };

  return (
    <div style={containerStyle}>
      <h1 style={{ color: '#3498db' }}>
        {isArabic ? 'دليل الاستخدام' : 'User Guide'}
      </h1>
      <p>
        {isArabic
          ? 'اتبع الخطوات التالية لاستخدام التطبيق:'
          : 'Follow these steps to use the application:'}
      </p>

      <ol style={{ lineHeight: '1.8' }}>
        <li>{isArabic ? 'سجّل حسابًا جديدًا كمطعم أو سائق.' : 'Register a new account as a restaurant or driver.'}</li>
        <li>{isArabic ? 'قم بتأكيد بياناتك واستكمل ملفك الشخصي.' : 'Verify your information and complete your profile.'}</li>
        <li>{isArabic ? 'ابدأ في إرسال واستلام الطلبات حسب دورك.' : 'Start sending and receiving orders as per your role.'}</li>
      </ol>

      <p style={{ marginTop: '20px', color: '#7f8c8d' }}>
        {isArabic
          ? 'للحصول على دعم إضافي، يرجى زيارة صفحة اتصل بنا.'
          : 'For additional support, please visit the Contact Us page.'}
      </p>
    </div>
  );
};

export default UserGuide;
